"use strict";
var appn;
(function (appn) {
    var saveMeState;
    (function (saveMeState_1) {
        const _namespace = 'appn.saveMeState';
        const _page = window.location.pathname;
        saveMeState_1.dbKey = _namespace + _page;
        let _providerId = null;
        let _afterChangedCallback;
        let _onResetCallback;
        function init(afterChangedCallback, onResetCallback, resetBtnContainerSelector) {
            _afterChangedCallback = afterChangedCallback;
            _onResetCallback = onResetCallback;
            _providerId = $('body').data('providerid');
            saveMeState_1.dbKey = _namespace + _page + '-' + _providerId;
            const $saveMeStateInputs = $('.saveMeState');
            $saveMeStateInputs.each(function (i, saveMeState) {
                const $saveMeState = $(saveMeState);
                const pageStateRegister = appn.localStorage.getItem(saveMeState_1.dbKey);
                const registerItem = findItemInRegister(getRegisterId($saveMeState), pageStateRegister);
                if (registerItem)
                    setElementValue($saveMeState, registerItem.value);
                const inputType = getInputType($saveMeState);
                if (inputType !== 'button.card-btn-expand-or-collapse' && inputType !== 'appnDateFilter' && inputType !== 'appnTaskTemplateFilter' && inputType !== 'appnFolderFilter' && inputType !== 'appnUserGroupFilter')
                    $saveMeState.off().on('change', function () {
                        const valueToSave = getElementValue($(this));
                        const registerId = getRegisterId($(this));
                        const registerItem = {
                            elementId: registerId,
                            value: valueToSave
                        };
                        appn.dataTable.resetPaging();
                        createOrUpdateRegister(registerItem);
                        if (registerItem && registerId && registerId === 'appnDateFilterMini')
                            appn.dateFilterMini.updateActiveOptions(valueToSave);
                        if (_afterChangedCallback)
                            _afterChangedCallback(saveMeState);
                    });
                else
                    $saveMeState.off().on('click', function (e) {
                        e.preventDefault();
                        let valueToSave = getElementValue($(this));
                        if (inputType === 'button.card-btn-expand-or-collapse')
                            if (valueToSave === 'expanded' || valueToSave === 'collapsed')
                                valueToSave = valueToSave === 'expanded' ? 'collapsed' : 'expanded';
                        const registerItem = {
                            elementId: getRegisterId($(this)),
                            value: valueToSave
                        };
                        appn.dataTable.resetPaging();
                        createOrUpdateRegister(registerItem);
                        if (inputType === 'appnDateFilter' || inputType === 'appnTaskTemplateFilter' || inputType === 'appnFolderFilter' || inputType === 'appnUserGroupFilter')
                            if (_afterChangedCallback)
                                _afterChangedCallback(saveMeState);
                    });
            });
            $('.btn-resetFilters').remove();
            if (resetBtnContainerSelector) {
                $(resetBtnContainerSelector).append(appn.dataTable.FILTER_RESET_BTN);
                appn.tooltip.init();
                $('.btn-resetFilters').off().on('click', function () {
                    resetState();
                    if (_onResetCallback) {
                        $saveMeStateInputs.each(function (_, saveMeState) {
                            const $saveMeState = $(saveMeState);
                            resetInput($saveMeState);
                        });
                        appn.select.init();
                        _onResetCallback();
                    }
                    else
                        appn.location.reloadCurrentPage();
                });
            }
        }
        saveMeState_1.init = init;
        function getRegisterId($element) {
            const inputType = getInputType($element);
            let elementId = $element.attr('id');
            if (!elementId)
                if (inputType === 'button.card-btn-expand-or-collapse') {
                    const $box = $element.closest('.card');
                    const connectorIdInput = $box.find('.card-body input[name$=".Id"]');
                    let boxId = $box.prop('id');
                    if (connectorIdInput)
                        boxId = boxId + '-' + connectorIdInput.val();
                    if (boxId)
                        return boxId;
                    const $boxTitle = $box.find('.card-title');
                    const textOnly = $boxTitle
                        .clone()
                        .children()
                        .remove()
                        .end()
                        .text();
                    elementId = textOnly.replace(/ /g, appn.emptyString);
                    if (elementId)
                        $element.prop('id', elementId);
                }
            return elementId;
        }
        saveMeState_1.getRegisterId = getRegisterId;
        function findItemInRegister(registerId, haystack) {
            if (!haystack || !registerId)
                return null;
            let itemMatch = null;
            $(haystack).each(function (i, item) {
                if (item.elementId === registerId) {
                    itemMatch = item;
                    return false;
                }
                return true;
            });
            return itemMatch;
        }
        saveMeState_1.findItemInRegister = findItemInRegister;
        function createOrUpdateRegister(registerItem) {
            let pageStateRegister = appn.localStorage.getItem(saveMeState_1.dbKey);
            if (!pageStateRegister)
                pageStateRegister = [registerItem];
            else {
                let foundMatch = false;
                $(pageStateRegister).each(function (i, item) {
                    if (item.elementId === registerItem.elementId) {
                        item.value = registerItem.value;
                        foundMatch = true;
                        return false;
                    }
                    return true;
                });
                if (!foundMatch)
                    pageStateRegister.push(registerItem);
            }
            appn.localStorage.setItem(saveMeState_1.dbKey, pageStateRegister);
            $('table.dataTable thead tr th input[type="checkbox"]').prop('checked', false);
        }
        saveMeState_1.createOrUpdateRegister = createOrUpdateRegister;
        function resetState() {
            appn.dataTable.clearSearch();
            appn.dataTable.resetPaging();
            clearPageStateRegister();
            appn.dataTable.uncheckAllRowsBox();
        }
        saveMeState_1.resetState = resetState;
        function getElementValue($element) {
            const inputType = getInputType($element);
            if (inputType === 'checkbox' || inputType === 'radio')
                return $element.prop('checked');
            if (inputType === 'select-one')
                return $element.val();
            if (inputType === 'button.card-btn-expand-or-collapse') {
                let isCurrentStateExpanded = false;
                const $parentBox = $element.closest('.card');
                if (!$parentBox.hasClass('collapsed-card'))
                    isCurrentStateExpanded = true;
                return isCurrentStateExpanded ? 'expanded' : 'collapsed';
            }
            if (inputType === 'appnDateFilter')
                return appn.dateFilter.getValueAsString();
            if (inputType === 'appnDateFilterMini')
                return appn.dateFilterMini.getValueAsString();
            if (inputType === 'appnTaskTemplateFilter')
                return appn.taskTemplateFilter.getValue();
            if (inputType === 'appnFolderFilter')
                return appn.folderFilter.getValue();
            if (inputType === 'appnUserGroupFilter')
                return appn.userGroupFilter.getValue();
            return null;
        }
        function setElementValue($element, value) {
            const inputType = getInputType($element);
            if (inputType === 'checkbox' || inputType === 'radio') {
                $element.prop('checked', value);
                return;
            }
            if (inputType === 'select-one') {
                const existsInSelect = valueExistsInSelect($element.attr('id'), value);
                if (!existsInSelect) {
                    const valueToSet = $('#' + $element.attr('id') + ' option:first').val();
                    $element.val(valueToSet);
                    const registerItem = {
                        elementId: $element.attr('id'),
                        value: $element.val()
                    };
                    createOrUpdateRegister(registerItem);
                    return;
                }
                $element.val(value);
                return;
            }
            if (inputType === 'button.card-btn-expand-or-collapse') {
                let isCurrentStateExpanded = false;
                const $parentBox = $element.closest('.card');
                if (!$parentBox.hasClass('collapsed-card'))
                    isCurrentStateExpanded = true;
                if (value === 'expanded') {
                    if (!isCurrentStateExpanded)
                        $element.click();
                }
                else if (isCurrentStateExpanded)
                    $element.click();
                return;
            }
            if (inputType === 'appnDateFilter') {
                appn.dateFilter.setValueFromString(value);
                return;
            }
            if (inputType === 'appnDateFilterMini') {
                appn.dateFilterMini.setValueFromString(value);
                return;
            }
            if (inputType === 'appnTaskTemplateFilter') {
                if (!appn.taskTemplateFilter.listContains(value)) {
                    value = appn.emptyString;
                    const registerItem = {
                        elementId: $element.attr('id'),
                        value: value
                    };
                    createOrUpdateRegister(registerItem);
                }
                appn.taskTemplateFilter.setValue(value);
                return;
            }
            if (inputType === 'appnFolderFilter') {
                if (!appn.folderFilter.listContains(value)) {
                    value = appn.emptyString;
                    const registerItem = {
                        elementId: $element.attr('id'),
                        value: value
                    };
                    createOrUpdateRegister(registerItem);
                }
                appn.folderFilter.setValue(value);
                return;
            }
            if (inputType === 'appnUserGroupFilter') {
                if (!appn.userGroupFilter.listContains(value)) {
                    value = appn.emptyString;
                    const registerItem = {
                        elementId: $element.attr('id'),
                        value: value
                    };
                    createOrUpdateRegister(registerItem);
                }
                appn.userGroupFilter.setValue(value);
                return;
            }
            $element.val(value);
        }
        function valueExistsInSelect(elementId, value) {
            let exists = false;
            $('#' + elementId + ' option').each(function () {
                if (this.value === value) {
                    exists = true;
                    return false;
                }
                return true;
            });
            return exists;
        }
        function isSelectOneHasBlankValue($selectOne) {
            const emptyOption = $selectOne.find('option[value=""]');
            return emptyOption.length > 0;
        }
        function resetInput($element) {
            const inputType = getInputType($element);
            if (inputType === 'checkbox' || inputType === 'radio') {
                $element.prop('checked', false);
                return;
            }
            if (inputType === 'select-one') {
                if (isSelectOneHasBlankValue($element))
                    $element.val(appn.emptyString);
                else
                    $element.val($element.find('option:first').val());
                return;
            }
            if (inputType === 'appnDateFilter') {
                appn.dateFilter.reset();
                return;
            }
            if (inputType === 'appnDateFilterMini') {
                appn.dateFilterMini.reset();
                return;
            }
            if (inputType === 'appnTaskTemplateFilter') {
                appn.taskTemplateFilter.reset();
                return;
            }
            if (inputType === 'appnFolderFilter') {
                appn.folderFilter.reset();
                return;
            }
            if (inputType === 'appnUserGroupFilter') {
                appn.userGroupFilter.reset();
            }
        }
        function getInputType($element) {
            let inputType = '';
            if ($element.is('input') && $element.prop('type') === 'checkbox')
                inputType = 'checkbox';
            if ($element.prop('type') === 'select-one')
                inputType = 'select-one';
            if ($element.prop('type') === 'radio')
                inputType = 'radio';
            if ($element.prop('type') === 'button')
                if ($element.hasClass('card-btn-expand-or-collapse'))
                    inputType = 'button.card-btn-expand-or-collapse';
                else
                    inputType = 'button';
            if ($element.hasClass('appnDateFilter'))
                inputType = 'appnDateFilter';
            if ($element.hasClass('appnDateFilterMini'))
                inputType = 'appnDateFilterMini';
            if ($element.hasClass('appnTaskTemplateFilter'))
                inputType = 'appnTaskTemplateFilter';
            if ($element.hasClass('appnFolderFilter'))
                inputType = 'appnFolderFilter';
            if ($element.hasClass('appnUserGroupFilter'))
                inputType = 'appnUserGroupFilter';
            return inputType;
        }
        function clearPageStateRegister() {
            appn.localStorage.removeItem(saveMeState_1.dbKey);
        }
        function clearPageStateRegisterItem(elementId) {
            const pageStateRegister = appn.localStorage.getItem(saveMeState_1.dbKey);
            if (!pageStateRegister)
                return;
            let indexToRemove = -1;
            $(pageStateRegister).each(function (i, item) {
                if (item.elementId === elementId) {
                    indexToRemove = i;
                    return false;
                }
                return true;
            });
            if (indexToRemove === -1)
                return;
            pageStateRegister.splice(indexToRemove, 1);
            appn.localStorage.setItem(saveMeState_1.dbKey, pageStateRegister);
        }
    })(saveMeState = appn.saveMeState || (appn.saveMeState = {}));
})(appn || (appn = {}));
